import PropTypes from 'prop-types';
import { Box, Typography, Paper, Divider, Tooltip, IconButton } from '@mui/material';
import { MoreVertOutlined } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { fadeUp } from '../utils/dashboardUtils';

const SectionCard = ({ title, subtitle, children, index, action }) => (
    <motion.div custom={index} variants={fadeUp} initial="hidden" animate="visible">
        <Paper elevation={0} sx={{ borderRadius: 3, border: '1px solid', borderColor: 'divider', overflow: 'hidden', height: '100%' }}>
            <Box sx={{ px: 3, pt: 2.5, pb: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="subtitle1" fontWeight={700}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="caption" color="text.secondary">
                            {subtitle}
                        </Typography>
                    )}
                </Box>
                {action || (
                    <Tooltip title="More options">
                        <IconButton size="small">
                            <MoreVertOutlined fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            <Divider />
            <Box sx={{ p: 2 }}>{children}</Box>
        </Paper>
    </motion.div>
);

SectionCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    children: PropTypes.node.isRequired,
    index: PropTypes.number.isRequired,
    action: PropTypes.node
};

export default SectionCard;
